import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UtilsService } from '../../../services/UtilsService';

@Component({
  selector: 'app-create-currency-pair',
  templateUrl: './create-currency-pair.component.html',
  styleUrls: ['./create-currency-pair.component.scss']
})
export class CreateCurrencyPairComponent implements OnInit {

  createEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  restCallInProgress: boolean;

  constructor(private readonly fb: FormBuilder,
              public readonly modalRef: BsModalRef) {
  }



  ngOnInit(): void {
    this.form = this.fb.group({
      // 6 characters
      sixLetterCode: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
      swapPriceFactor: new FormControl(null, [Validators.required, UtilsService.factorValidator()]),
      spotPriceFactor: new FormControl(null, [Validators.required, UtilsService.factorValidator()]),
      spotPricePrecision: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(12)]),
      swapPricePrecision: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(12)]),
      displaySpotPricePrecision: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(12)]),
      rounding: new FormControl(0, [Validators.required, UtilsService.roundingValidator()])
    });
  }

  createEvent() {
    if (this.form.invalid || this.restCallInProgress) {
      return;
    }
    this.restCallInProgress = true;
    this.createEventEmitter.emit(this.form.value);
    // this.modalRef.hide()
  }
}
